import { useEffect, useRef, useState } from "react";

export function useFakeInput() {
  const [scrollY, setScrollY] = useState(window.scrollY);
  const fakeInputRef = useRef(null);

  useEffect(() => {
    if (fakeInputRef.current) {
      return;
    }

    fakeInputRef.current = document.createElement("input");
    fakeInputRef.current.setAttribute("type", "text");
    fakeInputRef.current.style.position = "absolute";
    fakeInputRef.current.style.opacity = "0";
    fakeInputRef.current.style.height = "0";

    document.body.prepend(fakeInputRef.current);
    setScrollY(window.scrollY);

    fakeInputRef.current.focus();

    return () => {
      window.scrollTo(0, scrollY);
    };
  }, []);

  return fakeInputRef.current;
}
